<template>
  <div
    style="
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <v-card rounded class="pa-5 mt-12" min-width="50%">
      <div class="custom-title" style="margin-bottom: 30px">
        {{ $t(`SUPERADMINUSERS.title`) }}
      </div>
      <v-form ref="form" v-model="valid">
        <v-row justify="center">
          <v-col class="mx-5">
            <v-select
              id="users-email-select"
              v-model="selectedUser"
              dense
              outlined
              label="Email"
              :rules="[required]"
              :items="users"
              item-text="email"
              return-object
            ></v-select>
            <v-combobox
              id="users-roles-select"
              label="Roles"
              multiple
              outlined
              small-chips
              deletable-chips
              :rules="[required, isValid]"
              :items="roles"
              v-model="updatedRoles"
              :disabled="selectedUser ? false : true"
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row justify="end" class="mx-5">
          <v-btn
            id="users-cancel-button"
            @click="reset()"
            class="mr-2"
            text
            color="error"
            >Cancel</v-btn
          >
          <v-btn id="users-save-button" @click="changeRole()" class="success"
            >Save</v-btn
          >
        </v-row>
      </v-form>
    </v-card>
    <v-snackbar
      v-model="snackbar.show"
      top
      right
      :timeout="4000"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import { roles } from "@/helpers/roles.js";

export default {
  data: () => ({
    roles: [],
    selectedUser: null,
    updatedRoles: [],
    valid: false,
  }),
  methods: {
    reset() {
      this.selectedUser = null;
      this.role = null;
    },
    changeRole() {
      let list = [];
      if (this.$refs.form.validate()) {
        for (let i in roles) {
          list.push({ value: i, label: roles[i].label });
        }
        let newUser = Object.assign(this.selectedUser);
        newUser.roles = [];
        this.updatedRoles.forEach((r) => {
          newUser.roles.push(list.find((e) => e.label == r).value);
        });
        if (this.$store.dispatch("updateUserRole", newUser)) {
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Success on update Role!",
            color: "success",
          });
        } else {
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Oops... Error on update Role",
            color: "error",
          });
        }
      }
    },
    required(value) {
      if (value instanceof Array && value.length == 0) {
        return "Required.";
      }
      return !!value || "Required.";
    },
    isValid(value) {
      for (let i in value) {
        if (!this.roles.includes(value[i])) return "Not valid items.";
      }
      return true;
    },
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar.snackbar;
    },
    users() {
      return this.$store.getters.getUsers || [];
    },
  },
  watch: {
    selectedUser() {
      this.updatedRoles = [];
      if (this.selectedUser) {
        this.selectedUser.roles?.forEach((r) =>
          this.updatedRoles.push(roles[r].label)
        );
      }
    },
  },
  created() {
    for (var i in roles) {
      this.roles.push(roles[i].label);
    }
    if (!this.$store.getters.getUsers) {
      this.$store.dispatch("getAllUsers");
    }
  },
};
</script>

<style scoped>
.custom-title {
  color: rgb(114, 114, 114);
  font-size: 130%;
  font-weight: 500;
  display: flex;
  justify-content: center;
}
</style>
